import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_PROPOSAL_CONTENT,
    FETCH_PROPOSAL_CONTENT_FAILURE,
    FETCH_PROPOSAL_CONTENT_SUCCESS,
    FETCH_PROPOSAL_DETAILS,
    FETCH_PROPOSAL_DETAILS_SUCCESS,
    FETCH_PROPOSAL_DETAILS_FAILURE,
    RESET,
    SET_INITIALIZE,
    SET_IS_DOWNLOADING,
    SET_SELECTED_DOCUMENT,
    UPDATE_TEMPLATE,
    UPDATE_TEMPLATE_FAILURE,
    UPDATE_TEMPLATE_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    proposalContent: {
        data: {},
        errors: [],
        isFetching: false,
    },
    proposalDetails: {
        data: {},
        errors: [],
        isFetching: false,
    },
    initializing: false,
    isDownloading: false,
    selectedDocument: {
        id: null,
        name: '',
        type: 0,
    },
    updateCustomTemplate: {
        errors: [],
        isUpdating: false,
    },
};

const multiTemplateReviewSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_PROPOSAL_DETAILS]: (state) => {
            state.proposalDetails.isFetching = true;
        },
        [FETCH_PROPOSAL_DETAILS_FAILURE]: (state, action) => {
            state.proposalDetails = {
                ...state.proposalDetails,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROPOSAL_DETAILS_SUCCESS]: (state, action) => {
            state.proposalDetails = {
                ...state.proposalDetails,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROPOSAL_CONTENT]: (state) => {
            state.proposalContent.isFetching = true;
        },
        [FETCH_PROPOSAL_CONTENT_FAILURE]: (state, action) => {
            state.proposalContent = {
                ...state.proposalContent,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PROPOSAL_CONTENT_SUCCESS]: (state, action) => {
            state.proposalContent = {
                ...state.proposalContent,
                data: action.payload,
                isFetching: false,
            };
        },
        [RESET]: () => INITIAL_STATE,
        [SET_INITIALIZE]: (state, action) => {
            state.initializing = action.payload;
        },
        [SET_IS_DOWNLOADING]: (state, action) => {
            state.isDownloading = action.payload;
        },
        [SET_SELECTED_DOCUMENT]: (state, action) => {
            state.selectedDocument = action.payload;
        },
        [UPDATE_TEMPLATE]: (state) => {
            state.updateCustomTemplate = {
                ...state.updateCustomTemplate,
                errors: [],
                isUpdating: true,
            };
        },
        [UPDATE_TEMPLATE_FAILURE]: (state, action) => {
            state.updateCustomTemplate = {
                ...state.updateCustomTemplate,
                errors: action.payload,
                isUpdating: false,
            };
        },
        [UPDATE_TEMPLATE_SUCCESS]: (state) => {
            state.updateCustomTemplate.isUpdating = false;
        },
    },
});

export const multiTemplateReviewActions = multiTemplateReviewSlice.actions;

export default multiTemplateReviewSlice.reducer;
